import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { withAppContext } from '../utils/AppContext'

import style from '../scss/ui/listTile.scss'

class ListTile extends React.Component {
    constructor() {
        super()

        this.handleSlider = this.handleSlider.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
    }


    handleList({ appContext }, pos) {
        return appContext.list.filter(obj => {
            const position = Object.keys(obj)[2]
            return position === pos
        })[0]
    }

    handleCharacterImage({ appContext }, position) {
        if (appContext.list.length === 0) {
            // eslint-disable-next-line
            return <img src={require(`../images/list-tiles/blank.png`)} alt="blank placeholder" />
        }
        try {
            const altName = this.handleList({ appContext }, position).char
            const name = altName.replace(/[`'" ]+/g, '')
            // eslint-disable-next-line
            return <img src={require(`../images/list-tiles/${name}.png`)} alt={altName} />
        } catch (e) {
            console.log(e)
            // eslint-disable-next-line
            return <img src={require(`../images/list-tiles/blank.png`)} alt="blank placeholder" />
        }
    }

    handleSlider(e) {
        const { position, appContext } = this.props
        const positions = ['handScore', 'coinScore', 'whispersScore', 'commanderScore', 'grandMScore']
        const slide = positions.indexOf(position) + 2
        appContext.setContextState({ slideIndex: slide })
    }

    handleKeyDown(e) {
        const { position, appContext } = this.props
        if (e.keyCode === 13) {
            const positions = ['handScore', 'coinScore', 'whispersScore', 'commanderScore', 'grandMScore']
            const slide = positions.indexOf(position) + 2
            appContext.setContextState({ slideIndex: slide })
        }
    }

    render() {
        const { appContext, position, title, className } = this.props
        // const glow = position === appContext.isActive ? 'glow' : ''

        return (
            <Fragment>
                <div className={cx(style.listTile, className)} id={position}>
                    <p className={style.footer}>
                        {title}
                    </p>
                    <div
                        className={cx(style.listTileGraphic, position === appContext.isActive && 'glow')}
                        onClick={this.handleSlider}
                        onKeyDown={this.handleKeyDown}
                        tabIndex={0}
                        role="button"
                    >
                        {this.handleCharacterImage({ appContext }, position)}
                    </div>
                    <p className={style.footer}>
                        {appContext.list.length > 0 && this.handleList({ appContext }, position).char}
                    </p>
                </div>
            </Fragment>
        )
    }
}

ListTile.defaultProps = {
    className: '',
}

ListTile.propTypes = {
    appContext: PropTypes.object.isRequired,
    position: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
}

export default withAppContext(ListTile)



// WEBPACK FOOTER //
// ./src/ui/ListTile.js